if (!window.wandCartDrawerEnhancementsBound) {
  window.wandCartDrawerEnhancementsBound = true;

  const cartDrawerRoot = document.getElementById('CartDrawer');
  let wandCartDrawerCountBeforeRemoval = null;

  if (cartDrawerRoot) {
    cartDrawerRoot.addEventListener(
      'click',
      (event) => {
        // Dawn's stock quantity-input treats stepping down to 0 as a value
        // below quantity_rule.min (which defaults to 1 for ordinary products)
        // and resets it back to 1 instead of removing the line — so pressing
        // "-" at quantity 1 never removes the item. Intercept that specific
        // click, before Dawn's own bubble-phase handlers run, and reuse the
        // cart-drawer's existing (working) remove button instead of
        // re-implementing removal.
        const minusButton = event.target.closest('quantity-input .quantity__button[name="minus"]');
        if (minusButton) {
          const quantityInput = minusButton.closest('quantity-input');
          const input = quantityInput && quantityInput.querySelector('.quantity__input');
          if (!input || parseInt(input.value, 10) !== 1) return;

          const row = minusButton.closest('.cart-item');
          const removeButton = row && row.querySelector('cart-remove-button button');
          if (!removeButton || removeButton.disabled) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          removeButton.click();
          return;
        }

        // Snapshot the line count right before any remove action (direct
        // trash-icon click, or the synthetic click above) so the live-region
        // announcement below can tell "a line was removed" from "a line's
        // quantity was merely re-rendered" — every drawer update replaces the
        // whole item list, so node identity can't be used for that check.
        if (event.target.closest('cart-remove-button')) {
          wandCartDrawerCountBeforeRemoval = document.querySelectorAll('#CartDrawer .cart-item').length;
        }
      },
      true
    );
  }

  // Announce removals through the drawer's live region — cart.js only ever
  // writes to it on validation errors, so a clean removal is otherwise silent
  // for screen reader users.
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source !== 'cart-items' || wandCartDrawerCountBeforeRemoval === null) return;

    const cartData = event.cartData;
    const newLineCount = document.querySelectorAll('#CartDrawer .cart-item').length;
    const liveRegion = document.getElementById('CartDrawer-LiveRegionText');

    if (
      liveRegion &&
      newLineCount < wandCartDrawerCountBeforeRemoval &&
      !(cartData && cartData.errors) &&
      window.cartStrings &&
      window.cartStrings.itemRemoved
    ) {
      liveRegion.textContent = window.cartStrings.itemRemoved;
      liveRegion.setAttribute('aria-hidden', 'false');
      setTimeout(() => {
        liveRegion.setAttribute('aria-hidden', 'true');
      }, 1200);
    }

    wandCartDrawerCountBeforeRemoval = null;
  });
}
